import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TimesheetlistPage } from '../../pages/timesheetlist/timesheetlist';
import{ GlobalProvider } from '../../providers/global/global';
import { PopoverController } from 'ionic-angular';
import { PopoverPage } from '../popover/popover';

/**
 * Generated class for the ThankYouPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-thank-you',
  templateUrl: 'thank-you.html',
})
export class ThankYouPage {
  showRejectionMessage: boolean = false;
  constructor(public global: GlobalProvider, public navCtrl: NavController, public navParams: NavParams, public popoverCtrl: PopoverController) {
    var reject = this.navParams.get("rejection");
    if (reject == "1"){
      this.showRejectionMessage = true;
    }
  }

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({
      ev: myEvent
    });
  }

  backToTimesheets(){

    this.global.ndaysIndex = 1;
    this.navCtrl.push(TimesheetlistPage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ThankYouPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/thank-you/thank-you.ts